const styles = () => ({
  menuItem: {
    '&.ck-action-item--focused *, &.ck-action-item:hover *, &.ck-action-item:focus *': {
      color: '#fff !important',
    },
  },
});

export default styles;
